import React, { useState, useEffect } from "react";
import { motion } from 'framer-motion';
import { NewPageFormState } from "../types";
import { ClarifyingQuestionsStep } from "./ClarifyingQuestionsStep";

interface ContentPreferencesStepProps {
  value: NewPageFormState;
  onChange: (value: NewPageFormState) => void;
  workbookId: string;
}

export const ContentPreferencesStep: React.FC<ContentPreferencesStepProps> = ({
  value,
  onChange,
  workbookId,
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -20 }}
      transition={{ duration: 0.3 }}
      className="space-y-6"
    >
      {/* Clarifying Questions (This was originally step 3) */}
      <ClarifyingQuestionsStep 
        value={value}
        onChange={onChange}
        goalThreadId={workbookId}
      />

      {/* RESEARCH SECTION TEMPORARILY HIDDEN */}
      {/* 
      TODO: To re-enable research functionality:
      1. Add the research section back as step 3
      2. Change totalSteps back to 3 in useStepNavigation hook
      3. Update step validation logic to include research processing
      4. Move clarifying questions back to step 3
      */}
    </motion.div>
  );
}; 